import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import enAdmin from './en/admin.json'
import enGlobal from './en/global.json'
import en from './en/messages.json'
import enNotifications from './en/notifications.json'
import enToasts from './en/toasts.json'
import frAdmin from './fr/admin.json'
import frGlobal from './fr/global.json'
import fr from './fr/messages.json'
import frNotifications from './fr/notifications.json'
import frToasts from './fr/toasts.json'

export const resources = {
  en: {
    translation: en,
    admin: enAdmin,
    global: enGlobal,
    toasts: enToasts,
    notifications: enNotifications,
  },
  fr: {
    translation: fr,
    admin: frAdmin,
    global: frGlobal,
    toasts: frToasts,
    notifications: frNotifications,
  },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: 'fr', // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    load: 'languageOnly',
    supportedLngs: ['fr', 'en'],
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    detection: {
      order: [
        'localStorage',
        'cookie',
        'navigator',
        'htmlTag',
        'path',
        'subdomain',
      ],
      caches: ['localStorage', 'cookie'],
    },
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  })

export { default } from 'i18next'
